import qs from "qs";
import React, {useEffect, useState} from "react";
import {getResellerInfo} from "../apiUtils";
import LoaderComponent from "../LoaderComponent";
import { devLog } from '../commons/LogUtils';
import {isProductionEnv} from "../commons/VersionUtil";
import OurDomainScriptModule from "../OurDomainScriptCode";
import engagebayBaseAPI from "../api";

const ForgotPassword: React.FC = () => {

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [resellerData, setResellerData] = useState<any>();
    const [showLoader, setShowLoader] = useState(true);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await engagebayBaseAPI.post(
                "/rest/api/jsp-dependencies/forgot-password/reset",
                qs.stringify({ email }),
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
            );
            setMessage({type: "success", text: response.data});
        } catch (error: any) {
            console.error("Error:", error);
            setMessage({ type: "error", text: error.response.data ? error.response.data : "Something went wrong. Please try again later." });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getResellerInfo().then(data => {
            devLog(data);
            setResellerData(data);
            document.title = data.pageTitle;
            (document.getElementById("page-title") as HTMLElement).innerText = data.pageTitle;
            (document.getElementById("fav-icon") as HTMLLinkElement).href = data.favIcon;
            if (isProductionEnv() && data) {
                OurDomainScriptModule.injectOurDomainScriptCode(false, data.isClient, data.resellerID, null);
            }
        }).catch(error => {
            console.error("Error:", error);
        }).finally(
            () => setShowLoader(false),
        );
    }, []);

    if (showLoader) {
        return <LoaderComponent />;
    }


    return (
        <>
            {message && (
                message.type === "success" ?
                    <>
                        <div className="user-verification-noty success">
                            <div className="content">
                                <span>{message.text}</span>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="user-verification-noty error">
                            <div className="content">
                                <span>{message.text}</span>
                            </div>
                        </div>
                    </>
            )}

            <section className="login-main-bg">
                <div className="login-video">
                    <object className="login-video-autoplay" id="login-img-static" type="image/svg+xml" data="https://d2p078bqz5urf7.cloudfront.net/images/login/login-bg-animation.html"></object>
                </div>
                <div id="content-container" className={`container h-100`}>
                    <div className="row h-100">
                        <div className="col-12 col-lg-5 mx-auto">
                            <div className="card form-info-card">
                                <div className="form-info-header text-center pb-4 mb-2">
                                    <div className="logo-brand mb-4">
                                        <img className="logoimg in-iframe-hide" alt="Logo" height="32" src={resellerData.bigLogo} />
                                    </div>
                                    <h3 className="fw-500 text-dark mb-2 pb-1">Reset Password</h3>
                                    <p className="text-muted fs-13">Please enter the email address that you'd like us to send your password reset information to.</p>
                                </div>
                                <form name="loginForm" id="loginForm" onSubmit={handleSubmit}>
                                    <input type='hidden' name='command' value='forgot-password'/>
                                    <div className="form-group">
                                        <input type="email" className="form-control" value={email}
                                               onChange={(e) => setEmail(e.target.value)}
                                               placeholder="Enter your registered email address"
                                               pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,10}$" name="email" autoComplete="off"
                                               title="Enter a valid email address." required/>
                                    </div>
                                    <div className="d-grid pt-2">
                                        <button
                                            className="btn btn-lg btn-primary text-uppercase login-btn login-submit" type="submit" style={{ position: 'relative' }} disabled={isLoading}>
                                            {isLoading ? (
                                                <>
                                                    Submitting...
                                                    <i className="fa fa-circle-o-notch fa-spin" style={{ marginLeft: '5px', display: 'inline-block', visibility: 'visible' }}></i>
                                                </>
                                            ) : ("Submit")}
                                        </button>
                                    </div>
                                    <div className="text-center mt-4">
                                        <p className="text-muted fs-14">Already have an account <a href="/login" className="auth-switch-link">Login</a></p>
                                    </div>
                                </form>
                                {!resellerData?.isClient && (
                                <footer className={`copyright pt-4 lh-lg text-muted`}>&#169;{new Date().getFullYear()} EngageBay, Inc. All Rights Reserved.< br/>
                                    <a href="https://www.engagebay.com/legal/privacy-policy" target="_blank">Privacy Policy <span className="open-new-tab-icon"></span></a>
                                </footer>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ForgotPassword;